<div id="embed-game-view" class="embed-game-view">
    <vn-message-panel></vn-message-panel>
    <span class="game-launch-fail-close" *ngIf="!gameLaunchSuccess">
        <a (click)="close(true)">
            <span class="theme-close-i"></span>
        </a>
    </span>
    <div class="embed-left-section" *ngIf="gameLaunchSuccess">
        <div class="embed-left-section-width">
            <div class="embed-settings">
                <div class="client-time-full-screen" *ngIf="isFullScreen">
                    {{ date | date: 'shortTime' }}
                </div>
                <ul class="embed-list">
                    <!-- <li>
                        <button class="header-btn btn btn-primary ml-2" mat-raised-button (click)="openDialog()">{{depositButtonString}}</button>
                    </li> -->
                    <!-- <li *ngIf="isFullScreen && useFavouriteGames">
                        <a (click)="addFavourate(Game,$event)">
                            <span *ngIf="Game" [ngClass]="Game.isFavourite ? favouriteStyle : unFavouriteStyle"></span>
                        </a>
                    </li> -->
                    <!-- <li *ngIf="!isFullScreen">
                        <a (click)="openRequestedPopup()" src="" href="javascript:void(0)">
                            <span class="theme-pop-out"></span>
                        </a>
                    </li> -->
                    <li>
                        <a (click)="toggleFullScreen($event)">
                            <span [ngClass]="isFullScreen ? 'theme-fullscreen-exit' : 'theme-fullscreen'"></span>
                        </a>
                    </li>
                    <li *ngIf="!isFullScreen">
                        <a (click)="close(true)">
                            <span class="theme-close-i"></span>
                        </a>
                    </li>
                    <!-- <li *ngIf="extrasColumnFlag && !isFullScreen" style="position:relative;right:-50px;">
                        <a class="theme-left" (click)="toggleExtrasColumn()"></a>
                    </li> -->
                </ul>
            </div>
            <div class="embed-iframe">
                <!-- <div class="egv-game-loader"  [hidden]="isLoaderHide">
                    <div class="game-spinner"></div>
        </div> -->
                <ng-container *ngIf="iframeUrl">
                    <div class="gameOverlay">
                        <iframe
                            id="embedGameIframe"
                            class="iframeClass"
                            allowfullscreen="true"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            title=""
                            allow="autoplay"
                            [src]="iframeUrl"
                            [ngClass]="{ 'iframe-width': isIframeVisible == true }"></iframe>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
